export default __webpack_public_path__ + "static/media/ai.8277b119.png";